import { useEffect } from 'react'
import { useStoreActions } from '../../../store/hooks'

export const Settings = () => {
    const setOverlayTrigger = useStoreActions((state) => state.setOverlayTrigger)

    useEffect(() => {
        setOverlayTrigger('settings')
    }, [])

    return null
}
